import { lazy } from "react";

const NotFoundPageAsync = lazy(() => import('./NotFoundPage'));

export default NotFoundPageAsync;